"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable max-statements */
/** @jsx jsx */
/** @jsxFrag */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const modal_1 = require("src/context/modal");
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const common_components_1 = require("@yandex-int/pythia-libs/lib/common-components");
const markdown_renderer_1 = __importDefault(require("@yandex-int/pythia-libs/lib/markdown-renderer"));
const question_1 = __importDefault(require("../question"));
const option_1 = __importDefault(require("../question-choice/option"));
const icon_button_1 = __importDefault(require("../icon-button/icon-button"));
const question_sidebyside_styles_1 = __importDefault(require("./question-sidebyside.styles"));
// @ts-expect-error TS(2345): Argument of type 'readonly ["blockquote", "fence",... Remove this comment to see the full error message
const markdownRenderer = (0, markdown_renderer_1.default)(common_components_1.MARKDOWN_OPTIONS);
const b = b_1.default.with('sidebyside');
const UGCCabSideBySide = (props) => {
    var _a;
    const { handleClickNoAnswer, handleClickOption, label = '', noAnswer, options } = props;
    const currentOption = (_a = options.find(({ checked }) => checked)) !== null && _a !== void 0 ? _a : options[0];
    const questionLabel = markdownRenderer(label);
    const [seenOptions, setSeenOptions] = (0, react_2.useState)(new Set([currentOption.id]));
    const i18n = (0, i18n_1.default)(['sidebyside']);
    (0, react_2.useEffect)(() => {
        setSeenOptions(value => value.add(currentOption.id));
    }, [currentOption.id]);
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_sidebyside_styles_1.default }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('option-container') }, { children: (0, jsx_runtime_1.jsx)("img", { src: currentOption.url, className: b('option-image') }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('bottom-controls') }, { children: [(0, jsx_runtime_1.jsx)("div", { 
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: { __html: questionLabel }, className: b('question-label') }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('option-switch') }, { children: options.map(({ id, label: optionLabel = '' }) => ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'radio', id: id.toString(), name: 'option-switch', value: id }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: id.toString(), className: b('option-button', {
                                                checked: id === currentOption.id,
                                                active: id !== currentOption.id &&
                                                    seenOptions.size < options.length
                                            }), "data-value": id, onClick: handleClickOption }, { children: i18n(['option']).replace('%s', optionLabel) }), id)] }, id))) })), (0, jsx_runtime_1.jsx)("button", Object.assign({ className: b('no-answer-button'), onClick: handleClickNoAnswer }, { children: noAnswer.label || '' }))] }))] }))] })));
};
const SideBySideOptions = (props) => {
    const { handleClickOption, options, questionId } = props;
    const handleClick = (e) => {
        handleClickOption(e);
    };
    const { showImageModal } = (0, modal_1.useModalContext)();
    const handleLoopClick = (e, url) => {
        e.stopPropagation();
        showImageModal(url);
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('options') }, { children: options.map(option => {
            if (!option.url) {
                return null;
            }
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('option-container') }, { children: [(0, jsx_runtime_1.jsx)(option_1.default, { value: option.id, id: option.id.toString(), questionIndex: questionId, checked: option.checked, handleClickOption: handleClickOption }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('option', { checked: option.checked }), "data-value": option.id, onClick: handleClick }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('image-underlay'), "data-value": option.id }, { children: [(0, jsx_runtime_1.jsx)("img", { src: option.url, "data-value": option.id, className: b('image') }), (0, jsx_runtime_1.jsx)(icon_button_1.default, { type: 'loop', view: 'dl-default', size: 'm', onClick: e => handleLoopClick(e, option.url), className: b('loop') })] })) }))] }), option.id));
        }) })));
};
function DefaultSideBySide(props) {
    const { options, handleClickOption, id } = props, rest = __rest(props, ["options", "handleClickOption", "id"]);
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_sidebyside_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b() }, { children: (0, jsx_runtime_1.jsx)(SideBySideOptions, { handleClickOption: handleClickOption, options: options, questionId: id }) }))] })));
}
function SideBySide(props) {
    const { theme } = props;
    const Component = theme === 'ugc-cab' ? UGCCabSideBySide : DefaultSideBySide;
    return (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props));
}
exports.default = SideBySide;
